
import Vue from "vue";
export default Vue.extend({
	data(){
		return {
			text: ""
		};
	},
	props: {
		value: {
			type: Array as ()=>string[],
			required: true
		}
	},
	computed: {
		hasError():boolean{
			for (let val of this.textAsList){
				if (/[^\d\w\.]/.test(val)){
					return true;
				}
				if (val.startsWith(".") || val.endsWith(".")){
					return true;
				}
			}
			return false;
		},
		textAsList():string[]{
			let list = this.text.split("\n").map(s=>s.trim());
			list = list.filter(l=>l!="");
			list = list.filter((l, i)=>list.indexOf(l)==i);
			return list;
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.text = this.value.join("\n");
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		save(){
			this.$emit("input", this.textAsList);
			this.close();
		}
	}
});
